import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem } from '@src/services/interface';
import ShortContent from './shortContent';
import TranslateContent from './translateContent';
import PredictContent from './predictContent';
import styles from './index.css';

type ContentProps = {
    content: FeedFlowItem | null;
};

const Content = ({ content }: ContentProps) => {
    return (
        <div className={styles.contentBox}>
            {content?.type === 'short' && <ShortContent content={content} />}
            {content?.type === 'translate' && <TranslateContent content={content} />}
            {content?.type === 'predict' && <PredictContent content={content} />}
        </div>
    );
};

export default errorBoundary(Content);
